import FullScreenPage from "../../../components/FullScreenPage/FullScreenPage"
import UltimateBackground from "../../../components/UltimateBackground/UltimateBackground"
import UltimateSubfeaturesPopups from "../../../components/UltimateSubfeaturesPopups/UltimateSubfeaturesPopups"
import FeatureList from "../../../components/PromoComponents/UltimatePromoFeatureList/UltimatePromoFeatureList"
import Footer from "./Footer/Footer"
import Header from "./Header/Header"
import styles from "./PromoPremiumToUltimatePaywall.module.scss"

const PromoPremiumToUltimatePaywall = () => {
  return (
    <>
      <FullScreenPage containerClassName={styles.page}>
        <UltimateSubfeaturesPopups />
        <div className={styles.container}>
          <Header />
          <FeatureList />
          <Footer />
        </div>
      </FullScreenPage>
      <UltimateBackground forceVisible />
    </>
  )
}

export default PromoPremiumToUltimatePaywall
